import React, { FC } from "react";
import style from "./style.scss";

export interface FullHeightLayoutProps {
    children?: JSX.Element[] | JSX.Element;
}

export const FullHeightLayout: FC<FullHeightLayoutProps> = (props) => {
    return (
        <div className={style.layout}>
            <div className={style.contentLayout}>
                <div className={style.content}>{props.children}</div>
                {/* <SiteFooter /> */}
            </div>
        </div>
    );
};

export const FullHeightLayoutNoPadding: FC<FullHeightLayoutProps> = (props) => {
    return (
        <div className={style.layout} style={{ padding: "0px" }}>
            <div className={style.contentLayout} style={{ padding: "0px" }}>
                <div className={style.contentNoPadding}>{props.children}</div>
                {/* <SiteFooter /> */}
            </div>
        </div>
    );
};
